import { CrudModel } from "./_crud";

export class ServicePlanAppModel extends CrudModel {
	constructor() {
		super("app/servicePlan");
	}
}

export default new ServicePlanAppModel();
